import { render, staticRenderFns } from "./EmailRenderer.vue?vue&type=template&id=4795e4ba"
import script from "./EmailRenderer.vue?vue&type=script&lang=js"
export * from "./EmailRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports